import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { genericEntityActionCreators, commonActionCreators } from '../actions/genericEntityActionCreators';
import { connectGenericProps } from './index';
import { ContainerProvider } from './ContainerContext';
import PageWrapper from '../components/Layout/PageWrapper';
import MessagesModule from '../components/Layout/Modules/MessagesModule';
import { renderContainerChildren } from '../util/RenderUtil';

/** a container that handles loading collections/generating actions and passes these props down to its children */
class WrappedContainer extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    collection: PropTypes.array,
    /** see "src/actions/genericEntityActionCreators" for configuration */
    config: PropTypes.object.isRequired,
    currentEntity: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object,
    WrapperComponent: PropTypes.elementType
  };

  static defaultProps = {
    WrapperComponent: PageWrapper
  };

  constructor(props) {
    super(props);
    const { config, config: { actionCreators = {} }, dispatch } = props;
    
    this.actions = bindActionCreators({
      ...commonActionCreators,
      ...genericEntityActionCreators(config, props),
      ...actionCreators
    }, dispatch);
  }

  render() {
    const { WrapperComponent, ...additionalProps } = this.props;
    const containerProps = { ...additionalProps, ...this.actions };

    return (
      <ContainerProvider value={containerProps}>
        <WrapperComponent>
          {!this.props.config.excludeMessages && <MessagesModule />}
          {renderContainerChildren(containerProps)}
        </WrapperComponent>
      </ContainerProvider>
    );
  }
}

const createContainer = config => connectGenericProps(config)(WrappedContainer);

export default createContainer;
